import Breadcrumb from "components/Common/Breadcrumb"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
import React from "react"
import ReactQuill from "react-quill-new"
import "react-quill-new/dist/quill.snow.css"
import { useNavigate } from "react-router-dom"
import * as Yup from "yup"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import { useCreateBlogMutation } from "store/api/blogs/blog"
import toast from "react-hot-toast"

const Blogs = ({ user_type }) => {
  const [mutate, { isLoading }] = useCreateBlogMutation()
  const navigate = useNavigate()

  //meta title
  document.title = "Create blog | Prachay"

  const createBlog = async (values) => {
    try {
      const { success, message } = await mutate({
        ...values,
        user_type,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "blogSuccess" })
        navigate(user_type === "INVESTOR" ? "/resources/blogs" : "/wp-blogs")
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    // ["blockquote", "code-block"],
    ["link", "image"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    // [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ]

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { title: "", status: "", blog: "" },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await createBlog(values)
    },
  })

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"Create Blog"} />

        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <Form
                  className="form-horizontal"
                  onSubmit={(e) => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row className="mb-2">
                    <Col sm={6} className="mb-2">
                      <Label className="form-label">
                        Title<span className="error">*</span>
                      </Label>
                      <Input
                        name="title"
                        className="form-control"
                        placeholder={"Enter Title"}
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.title}
                        invalid={
                          validation.touched.title && validation.errors.title
                        }
                      />
                      {validation.touched.title && validation.errors.title ? (
                        <FormFeedback type="invalid">
                          {validation.errors.title}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col xl={6} className="mb-2">
                      <Label className="form-label">
                        Status<span className="error">*</span>
                      </Label>
                      <select
                        name="status"
                        className="form-select pageSize mb-2"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.status}
                      >
                        <option>Select Status</option>
                        {[
                          { label: "ACTIVE", value: "ACTIVE" },
                          { label: "DISABLE", value: "DISABLE" },
                        ].map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      {validation.touched.status && validation.errors.status ? (
                        <FormFeedback type="invalid">
                          {validation.errors.status}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col sm={12}>
                      <ReactQuill
                        theme="snow"
                        value={validation.values.blog}
                        onChange={(e) => validation.setFieldValue("blog", e)}
                        placeholder="Enter Blog Content..."
                        modules={{
                          toolbar: toolbarOptions,
                        }}
                      />
                      {validation.touched.blog && validation.errors.blog ? (
                        <FormFeedback type="invalid">
                          {validation.errors.blog}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>

                  <Row className="justify-content-end mt-4">
                    <Col sm={12}>
                      <div className="d-flex justify-content-end align-items-center gap-3">
                        {/* <Link to={"/icd"}>
                          <button className="btn btn-cancel w-md">
                            Cancel
                          </button>
                        </Link> */}
                        <Button type="submit" className="btn btn-primary w-md">
                          {isLoading ? <Spinners /> : "Create Blog"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Blogs
